import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_BOOKING_SUMMARY, GET_BOOKING_SUMMARY_ERROR, GET_BOOKING_SUMMARY_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getBookingSummaryData({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/downloads/booking-dump-type-list`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetBookingSummaryData() {
  yield takeEvery(GET_BOOKING_SUMMARY, getBookingSummaryData);
}

function* getBookingSummaryDataSaga() {
  yield all([fork(watchGetBookingSummaryData)]);
}

export default getBookingSummaryDataSaga;
